import React from 'react';
import PropTypes, { arrayOf } from 'prop-types';
import { useTranslation } from 'react-i18next';
import EmailTemplateRow from './EmailTemplateRow';
import { emailTemplatesType, productType, sortingParamType } from '../../types';
import SortControl from '../SortControl';
import './_styles_/EmailTemplatesList.css';

EmailTemplatesList.propTypes = {
    availableProducts: arrayOf(productType),
    activeProductType: PropTypes.string,
    emailTemplates: emailTemplatesType.isRequired,
    onSort: PropTypes.func.isRequired,
    sortingParam: sortingParamType.isRequired,
    onClone: PropTypes.func.isRequired,
};

function EmailTemplatesList(props) {
    const {
        availableProducts = [],
        activeProductType = null,
        emailTemplates,
        onSort,
        sortingParam,
        onClone,
    } = props;
    const { t } = useTranslation();

    return (
        <div className="email-templates-list">
            <div className="rich-list-row rich-list-header email-templates-list--header">
                <div className="email-template-header--values--name">
                    <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="name">
                        {t('email-templates.list-header.name')}
                    </SortControl>
                </div>
                <div className="email-template-header--values--product">
                    <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="product.productId">
                        {t('email-templates.list-header.product')}
                    </SortControl>
                </div>
                <div className="email-template-header--values--recipients">
                    <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="recipients">
                        {t('email-templates.list-header.recipients')}
                    </SortControl>
                </div>
                <div className="email-template-header--values--actions" />
            </div>
            {
                emailTemplates.length
                    ? emailTemplates.map((emailTemplate) => (
                        <EmailTemplateRow
                            availableProducts={availableProducts}
                            activeProductType={activeProductType}
                            emailTemplate={emailTemplate}
                            onClone={onClone}
                            key={emailTemplate.id}
                        />
                    ))
                    : (<div className="email-templates-no-items">{t('email-templates.no-items')}</div>)
            }
        </div>
    );
}

export default EmailTemplatesList;
